import classNames from "classnames";
import React from "react";
import { SimpleFieldProps, useSimpleFieldProps } from "./FormTools";
import { ErrorMessage } from "./Tools";

export function Switch(props: {
  field: SimpleFieldProps<boolean>;
  children?: React.ReactNode;
  noVerticalSlop?: boolean;
  style?: React.CSSProperties;
  isDisabled?: boolean;
  isLoading?: boolean;
}) {
  const field = useSimpleFieldProps(props.field);
  return (
    <div className="control" style={props.style}>
      <input
        type="checkbox"
        className={classNames("switch is-rounded", {
          "input-validation-error": field.error,
          "is-loading": props.isLoading,
        })}
        id={field.name}
        name={field.name}
        onFocus={e => field.onFocus(e.target.checked)}
        onChange={e => field.onChange(e.target.checked)}
        onBlur={e => field.onBlur(e.target.checked)}
        checked={field.value}
        disabled={props.isDisabled === true || props.isLoading === true}
      />
      <label
        htmlFor={field.name}
        className={classNames({ "no-vertical-slop": props.noVerticalSlop })}
      >
        {props.children}
      </label>
      <ErrorMessage>{field.error}</ErrorMessage>
    </div>
  );
}
